// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"080e9ffb","239":"7bf0e301","455":"e0a54646"}[chunkId] + ".chunk.js";
};